module.exports = __webpack_public_path__ + "static/img/shuqitui-official-account-qr.1babeb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/shuqitui-official-account-qr.jpg
// module id = G6AX
// module chunks = 6